
import axios from 'axios';
export default ({ to, from, next }) => {
    if (!localStorage.getItem('toaomt_token')) {
        window.location.href = "/login";
        return false
    }
    if (localStorage.getItem('toaomt_token') != undefined || localStorage.getItem('toaomt_token') != 'undefined') {
        axios.get(process.env.VUE_APP_API_URL_BACKEND + 'authentication', {
            headers: {
                'x-access-token': localStorage.toaomt_token
            }
        })
            .then(res => {
                if (res.status === 401) {
                    window.location.href = "/login";
                    return false
                }
            })
            .catch(err => {
                window.location.href = "/login";
                return false
            })
    }
    next()
}